export default __webpack_public_path__ + "static/media/HospitalNetwork.0f2f9567.svg";